import { EntityState } from '@ngrx/entity';
import { Culture } from '../../models/culture';

export const cultureFeatureKey = 'cultures';

export interface CultureState extends EntityState<Culture> {
  error: any;
  totalCount: number;
}
